import { lazy, Suspense, type ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminAuth from './components/AdminAuth';
import WhatsAppButton from './components/WhatsAppButton';

const Demo = lazy(() => import('./pages/Demo'));
const Calculator = lazy(() => import('./pages/Calculator'));
const CentreCost = lazy(() => import('./pages/CentreCost'));
const HRPontaj = lazy(() => import('./pages/HRPontaj'));
const Logistica = lazy(() => import('./pages/Logistica'));
const Achizitii = lazy(() => import('./pages/Achizitii'));
const Echipamente = lazy(() => import('./pages/Echipamente'));
const Documente = lazy(() => import('./pages/Documente'));
const Despre = lazy(() => import('./pages/Despre'));
const Comparatie = lazy(() => import('./pages/Comparatie'));
const ConfirmareDemo = lazy(() => import('./pages/ConfirmareDemo'));
const ConfirmareContact = lazy(() => import('./pages/ConfirmareContact'));
const Contact = lazy(() => import('./pages/Contact'));
const Termeni = lazy(() => import('./pages/Termeni'));
const Confidentialitate = lazy(() => import('./pages/Confidentialitate'));
const GDPR = lazy(() => import('./pages/GDPR'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Newsletter = lazy(() => import('./pages/Newsletter'));
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'));
const EmailAdmin = lazy(() => import('./pages/EmailAdmin'));
const FacebookLeads = lazy(() => import('./pages/FacebookLeads'));
const NotificationSettings = lazy(() => import('./pages/NotificationSettings'));

const PageLoader = () => (
  <div className="min-h-screen bg-[#0E0A31] flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin" />
  </div>
);

const withSuspense = (element: ReactNode) => (
  <Suspense fallback={<PageLoader />}>{element}</Suspense>
);

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demo" element={withSuspense(<Demo />)} />
        <Route path="/calculator" element={withSuspense(<Calculator />)} />
        <Route path="/centre-cost" element={withSuspense(<CentreCost />)} />
        <Route path="/hr-pontaj" element={withSuspense(<HRPontaj />)} />
        <Route path="/logistica" element={withSuspense(<Logistica />)} />
        <Route path="/achizitii" element={withSuspense(<Achizitii />)} />
        <Route path="/echipamente" element={withSuspense(<Echipamente />)} />
        <Route path="/documente" element={withSuspense(<Documente />)} />
        <Route path="/despre" element={withSuspense(<Despre />)} />
        <Route path="/comparatie" element={withSuspense(<Comparatie />)} />
        <Route path="/confirmare-demo" element={withSuspense(<ConfirmareDemo />)} />
        <Route path="/confirmare-contact" element={withSuspense(<ConfirmareContact />)} />
        <Route path="/contact" element={withSuspense(<Contact />)} />
        <Route path="/blog" element={withSuspense(<Blog />)} />
        <Route path="/blog/:slug" element={withSuspense(<BlogPost />)} />
        <Route path="/newsletter" element={withSuspense(<Newsletter />)} />
        <Route path="/unsubscribe" element={withSuspense(<Unsubscribe />)} />
        <Route path="/admin/email" element={withSuspense(<AdminAuth><EmailAdmin /></AdminAuth>)} />
        <Route path="/admin/facebook-leads" element={withSuspense(<AdminAuth><FacebookLeads /></AdminAuth>)} />
        <Route path="/admin/notifications" element={withSuspense(<AdminAuth><NotificationSettings /></AdminAuth>)} />
        <Route path="/termeni" element={withSuspense(<Termeni />)} />
        <Route path="/confidentialitate" element={withSuspense(<Confidentialitate />)} />
        <Route path="/gdpr" element={withSuspense(<GDPR />)} />
        <Route path="/en">
          <Route index element={<Home />} />
          <Route path="demo" element={withSuspense(<Demo />)} />
          <Route path="calculator" element={withSuspense(<Calculator />)} />
          <Route path="centre-cost" element={withSuspense(<CentreCost />)} />
          <Route path="hr-pontaj" element={withSuspense(<HRPontaj />)} />
          <Route path="logistica" element={withSuspense(<Logistica />)} />
          <Route path="achizitii" element={withSuspense(<Achizitii />)} />
          <Route path="echipamente" element={withSuspense(<Echipamente />)} />
          <Route path="documente" element={withSuspense(<Documente />)} />
          <Route path="despre" element={withSuspense(<Despre />)} />
          <Route path="comparatie" element={withSuspense(<Comparatie />)} />
          <Route path="confirmare-demo" element={withSuspense(<ConfirmareDemo />)} />
          <Route path="confirmare-contact" element={withSuspense(<ConfirmareContact />)} />
          <Route path="contact" element={withSuspense(<Contact />)} />
          <Route path="blog" element={withSuspense(<Blog />)} />
          <Route path="blog/:slug" element={withSuspense(<BlogPost />)} />
          <Route path="newsletter" element={withSuspense(<Newsletter />)} />
          <Route path="unsubscribe" element={withSuspense(<Unsubscribe />)} />
          <Route path="admin/email" element={withSuspense(<AdminAuth><EmailAdmin /></AdminAuth>)} />
          <Route path="admin/facebook-leads" element={withSuspense(<AdminAuth><FacebookLeads /></AdminAuth>)} />
          <Route path="admin/notifications" element={withSuspense(<AdminAuth><NotificationSettings /></AdminAuth>)} />
          <Route path="termeni" element={withSuspense(<Termeni />)} />
          <Route path="confidentialitate" element={withSuspense(<Confidentialitate />)} />
          <Route path="gdpr" element={withSuspense(<GDPR />)} />
        </Route>
      </Routes>
      <WhatsAppButton />
    </>
  );
}

export default App;
